// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__jYJje","divider-animate":"Divider_divider-animate__JU3g+","slideInFromLeft":"Divider_slideInFromLeft__qIgGT"};